import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '../LocaleProvider';
export var isLikeText = function isLikeText(node) {
  if (typeof node === 'string') {
    return true;
  }

  if (isValidElement(node) && node.type === Translate) {
    var _node$props = node.props,
        component = _node$props.component,
        children = _node$props.children;

    if (component === 'span' && (typeof children === 'string' || typeof children === 'undefined' || children === null)) {
      return true;
    }
  }

  return false;
};
/**
 * `Translate` component.
 * @since 0.0.42
 */

var Translate = function Translate(_ref) {
  var Tag = _ref.component,
      content = _ref.content,
      children = _ref.children,
      params = _ref.params,
      unsafe = _ref.unsafe,
      fallback = _ref.fallback,
      namespace = _ref.namespace,
      translators = _ref.translators,
      props = _objectWithoutProperties(_ref, ["component", "content", "children", "params", "unsafe", "fallback", "namespace", "translators"]);

  var translate = useTranslate(namespace);
  var key = content || children;
  var translator = translators && translators[key];

  if (translator) {
    if (typeof translator === 'function') {
      return translator(params);
    }

    return translator;
  }

  var message = translate(key, params, fallback);

  if (unsafe) {
    props.dangerouslySetInnerHTML = {
      __html: message
    };
  } else {
    props.children = message;
  }

  return React.createElement(Tag, props);
};

Translate.propTypes = {
  /**
   * A some prefix for the message key.
   * @since 2.6.0
   */
  namespace: PropTypes.string,

  /**
   * Translatable content or message key.
   * @since 0.0.42
   */
  content: PropTypes.string,

  /**
   * Message params
   * @since 0.0.42
   */
  params: PropTypes.object,

  /**
   * Fallback translation value.
   * @since 0.0.47
   */
  fallback: PropTypes.string,

  /**
   * Component to render as the root element. Useful when rendering a `Translate` as `<option>`.
   * @since 0.0.42
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * A set of translation messages. If the set contains a message key, the component uses an item from the set for rendering.
   * @ignore
   */
  translators: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.func, PropTypes.node])),

  /**
   * @ignore
   */
  unsafe: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.string
};
Translate.defaultProps = {
  namespace: undefined,
  content: undefined,
  params: undefined,
  component: 'span',
  unsafe: undefined,
  fallback: undefined,
  children: undefined,
  translators: undefined
};
export default Translate;